module.exports = __webpack_public_path__ + "static/media/front.2525f1c6.jpg";